<template>
  <div class="main">
    <div class="container">
      <div class="main__content">
        <h1 class="main__title">
          Создавайте и продавайте <br>
          свои курсы легко, <span class="text-blue">удобно и быстро</span>
        </h1>
        <p class="text-gold">№1 LMS в Казахстане</p>
        <h4 class="main__subtitle">Попробуйте демо версию совершенно бесплатно и убедитесь сами </h4>
        <div class="main__btns">
          <!-- <button class="main-btn btn-green" @click="freeDemoOpen()">Попробовать 5 дней бесплатно </button> -->
          <a href="https://demo.educenter.kz" class="main-btn btn-green" target="_blank" rel="noopener">Демо версия</a>
        </div>
        <div class="main__feedback">
          <button class="" @click="freeApplicationFormOpen()">Связаться с нами
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_13_2)">
                <path d="M17.143 2.44497C15.88 3.36597 14.924 4.65997 14.11 5.84897L13.472 6.78697C13.2739 7.07653 13.1832 7.42625 13.2157 7.7756C13.2482 8.12494 13.4018 8.45193 13.65 8.69997L15.006 10.056L14.863 10.36C14.513 11.069 13.909 12.09 13 13C12.3723 13.6182 11.6647 14.1496 10.896 14.58L10.529 14.777L10.202 14.939L10.056 15.006L8.70098 13.65C8.45197 13.4013 8.12353 13.2479 7.77299 13.2167C7.42245 13.1854 7.07207 13.2783 6.78299 13.479L5.76898 14.182C4.61698 14.992 3.41398 15.915 2.47898 17.113C2.31736 17.3209 2.21455 17.5684 2.1813 17.8296C2.14805 18.0908 2.18559 18.3562 2.28999 18.598C3.12699 20.551 5.24498 22.214 7.44798 22.132L7.74798 22.116L7.98099 22.096L8.23899 22.066L8.51999 22.028L8.82498 21.977L9.15098 21.913L9.49698 21.836L9.86298 21.742L10.248 21.632L10.65 21.502C12.496 20.876 14.839 19.646 17.243 17.242C19.646 14.839 20.876 12.496 21.502 10.65L21.632 10.248L21.742 9.86297L21.836 9.49697L21.914 9.15097C21.9365 9.04261 21.9575 8.93393 21.977 8.82497L22.027 8.51997L22.067 8.23897L22.096 7.98097L22.116 7.74797L22.132 7.44797C22.213 5.25197 20.532 3.11897 18.588 2.28597C18.354 2.18494 18.0978 2.14647 17.8445 2.17435C17.5911 2.20222 17.3494 2.29548 17.143 2.44497ZM18.07 4.25297C19.142 4.81297 20.18 6.09297 20.133 7.37397L20.113 7.70197L20.091 7.90697L20.062 8.13697L20.022 8.38997L19.971 8.66697L19.906 8.96497L19.826 9.28497L19.73 9.62397L19.616 9.98197C19.574 10.104 19.53 10.229 19.482 10.357L19.328 10.749L19.152 11.156C18.524 12.538 17.5 14.156 15.827 15.828C14.155 17.5 12.537 18.525 11.155 19.153L10.748 19.329L10.356 19.483C10.228 19.531 10.103 19.575 9.98098 19.617L9.62298 19.731L9.28298 19.827L8.96398 19.907L8.66599 19.972L8.38898 20.023L8.13498 20.063L7.90499 20.093L7.70098 20.113L7.37298 20.133C6.10898 20.18 4.81898 19.148 4.26098 18.09C4.97298 17.255 5.85699 16.57 6.83199 15.88L7.57998 15.359L7.76999 15.558L8.17598 16.001L8.39098 16.227C8.97698 16.824 9.66098 17.331 10.481 17L10.707 16.905L10.983 16.781L11.137 16.708L11.475 16.539L11.846 16.339C12.7849 15.8165 13.6484 15.1689 14.413 14.414C15.1679 13.6494 15.8155 12.7858 16.338 11.847L16.538 11.477L16.708 11.138L16.904 10.708L17 10.48C17.311 9.71097 16.883 9.06197 16.336 8.49997L16.112 8.27997L15.555 7.76697L15.355 7.57697L15.828 6.88397C16.531 5.86397 17.218 4.94397 18.071 4.25197L18.07 4.25297ZM9.00698 6.03997L8.89098 6.05297C8.16308 6.18137 7.4945 6.53691 6.98109 7.06865C6.46768 7.60039 6.13579 8.28101 6.03299 9.01297C5.99633 9.26615 6.0581 9.52375 6.20559 9.73277C6.35308 9.9418 6.57506 10.0864 6.82588 10.1367C7.07669 10.187 7.33727 10.1393 7.55399 10.0034C7.77071 9.8675 7.9271 9.65369 7.99098 9.40597L8.01398 9.29097C8.05422 9.00407 8.17667 8.73496 8.36655 8.51616C8.55643 8.29735 8.80561 8.13821 9.08398 8.05797L9.23899 8.02297C9.49009 7.97847 9.7147 7.83971 9.86688 7.63508C10.0191 7.43045 10.0873 7.17541 10.0577 6.92212C10.0281 6.66883 9.90277 6.43643 9.70746 6.27245C9.51216 6.10848 9.26158 6.02531 9.00698 6.03997ZM8.99998 2.99997C7.40869 2.99997 5.88256 3.63211 4.75734 4.75733C3.63213 5.88255 2.99998 7.40867 2.99998 8.99997C3.00027 9.25485 3.09786 9.5 3.27283 9.68534C3.4478 9.87068 3.68694 9.98221 3.94138 9.99714C4.19582 10.0121 4.44636 9.9293 4.64182 9.76571C4.83727 9.60212 4.96288 9.37007 4.99298 9.11697L4.99998 8.99997C4.99961 7.98439 5.38575 7.00673 6.08 6.2655C6.77424 5.52426 7.72455 5.07502 8.73798 5.00897L8.99998 4.99997C9.2652 4.99997 9.51955 4.89461 9.70709 4.70708C9.89463 4.51954 9.99998 4.26519 9.99998 3.99997C9.99998 3.73475 9.89463 3.4804 9.70709 3.29286C9.51955 3.10533 9.2652 2.99997 8.99998 2.99997Z" fill="#35B535"/>
              </g>
              <defs>
                <clipPath id="clip0_13_2">
                  <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                </clipPath>
              </defs>
            </svg>
          </button>
        </div>
      </div>
<!--      <div class="main__banner">-->
<!--        <a href="https://wa.me/+77085767736" class="circle" target="_blank">-->
<!--          <div class="head">-->
<!--            <div class="head-logo">-->
<!--&lt;!&ndash;              <img src="../../../../assets/images/banner/kaspi-logo-white.png" alt="" style="width: 25px; height: 25px">&ndash;&gt;-->
<!--              <img src="../../../../assets/images/banner/blackfriday-logo.png" alt="" style="width: 160px; object-fit: contain;">-->
<!--&lt;!&ndash;              <p class="text">Black Friday</p>&ndash;&gt;-->
<!--            </div>-->
<!--            <div class="text border">21-30 ноября</div>-->
<!--          </div>-->
<!--          <div class="middle">-->
<!--            <div class="text">0-0-12</div>-->
<!--          </div>-->
<!--          <div class="foot">-->
<!--            <div class="text"><strong>-35%</strong> на тариф "ПОКУПКА"</div>-->
<!--            <div class="text">-->
<!--              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path d="M24.888 30.0004H7.112C6.83614 30.0029 6.5625 29.9509 6.30683 29.8473C6.05115 29.7436 5.81849 29.5905 5.62221 29.3966C5.42593 29.2028 5.26992 28.972 5.16313 28.7176C5.05635 28.4633 5.00091 28.1903 5 27.9144V15.0004L15.877 11.9404L27 15.0004V27.9144C27 29.0604 26.06 30.0004 24.888 30.0004Z" fill="#FCD53F"/>-->
<!--                <path d="M27 5.84717C27 2.46317 22.955 0.741171 20.534 3.08417L16 7.47917L11.466 3.08417C9.046 0.73017 5 2.46317 5 5.84717C5 7.04017 5.957 8.00017 7.142 8.00017L16 10.1702L24.858 8.00017C25.4268 7.99622 25.971 7.76776 26.3721 7.36454C26.7733 6.96132 26.999 6.41596 27 5.84717Z" fill="#F8312F"/>-->
<!--                <path d="M27.662 8H4.337C3.6 8 3 8.6 3 9.342V13.658C3 14.4 3.6 15 4.338 15H27.662C28.4 15 29 14.4 29 13.658V9.342C29 8.6 28.4 8 27.662 8Z" fill="#FFB02E"/>-->
<!--                <path d="M16.005 3C14.345 3 13 4.37 13 6.06V30H19V6.06C19.01 4.37 17.666 3 16.005 3Z" fill="#CA0B4A"/>-->
<!--              </svg>-->
<!--              iOS/Android App/Bridgy-->
<!--            </div>-->
<!--&lt;!&ndash;            <div class="v">осталось <br>{{timerOutput}}</div>&ndash;&gt;-->
<!--          </div>-->
<!--        </a>-->
<!--      </div>-->
      <div class="main__img">
        <img src="../../../../assets/images/img-main-1.png" alt="" class="">
      </div>
<!--      <div class="main__slider">-->
<!--        <div ref="prevMain1" class="prev-btn-1 swiper-button-prev"></div>-->
<!--        <swiper class="bannerSwiper"-->
<!--            :slides-per-view="1"-->
<!--            :space-between="50"-->
<!--            @swiper="onSwiper"-->
<!--            @slideChange="onSlideChange"-->
<!--            :navigation="{-->
<!--              prevEl: '.prev-btn-1',-->
<!--              nextEl: '.next-btn-1',-->
<!--            }"-->
<!--            :autoplay="{-->
<!--              delay: 4500,-->
<!--            }"-->
<!--            :modules="modules"-->
<!--            :pagination="{-->
<!--              el: paginationMain1,-->
<!--            }"-->
<!--          >-->
<!--          <swiper-slide v-for="(bannerImage, i) of bannerImages" :key="i">-->
<!--            <a href="https://wa.me/+77085767736" target="_blank">-->
<!--              <img :src="bannerImage.img" alt="">-->
<!--            </a>-->
<!--          </swiper-slide>-->
<!--          <div ref="paginationMain1" class="pagination">-->
<!--          </div>-->
<!--        </swiper>-->
<!--        <div ref="nextMain1" class="next-btn-1 swiper-button-next"></div>-->
<!--      </div>-->
    </div>
    <div class="marquee">
      <div class="marquee__inner" aria-hidden="true">
        <span v-for="(item, i) of 4" :key="i">
          EduCenter — это новейшие технологии, высокая конфиденциальность, индивидуальная платформа для каждого пользователя.
        </span>
      </div>
    </div>
    <div class="main__modal" :class="{ 'isFreeDemo': isFreeDemo }" >
      <div class="main__modal-back" @click="modalClose()" ></div>
      <div class="main__modal-card">
        <div class="main__modal-header">
          <h3 class="text-uppercase">Выберите Бесплатную демо-версию </h3>
          <svg class="main__modal-close-btn" @click="modalClose()" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="3.06066" y1="2.73914" x2="21.0607" y2="20.7391" stroke="#222222" stroke-width="3"/>
            <line x1="21.0607" y1="3.06066" x2="3.06066" y2="21.0607" stroke="#222222" stroke-width="3"/>
          </svg>
        </div>
        <div class="main__modal-body">
          <p>5 дней совершенно бесплатно</p>
        </div>
        <div class="main__modal-footer">
          <router-link to="/create-platform" class="btn-green">Пробная версия</router-link>
          <a :href="deviceLink" class="btn-green" target="_blank" @click="deviceDetection()">Мобильного приложения</a>
        </div>
      </div>
    </div>
  </div>

  <ModalForm :isAppForm="isApplicationForm" :modalClose="modalClose"/>
</template>

<style>
.main__slider .pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: var(--main2-color) !important;
}
</style>

<script>
import ModalForm from "@/components/Modals/Form/Questions.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import {ref} from "vue";
import {A11y, Autoplay, Navigation, Pagination, Scrollbar} from "swiper";

export default {
  components: {Swiper, SwiperSlide, ModalForm},
  data() {
    return {
      deviceLink: '',
      isFreeDemo: false,
      isApplicationForm: false,
      bannerImages: [
        {
          img: require('../../../../assets/images/banner/banner - sale30.jpg'),
        },
        {
          img: require('../../../../assets/images/banner/kaspi-0-0-12.jpeg'),
        },
      ],
      // countDownToTime : new Date("Nov 4, 2023 00:00:00").getTime(),
      // timerOutput:  null
    }
  },
  setup() {
    const onSwiper = (swiper) => {
      // console.log(swiper);
    };
    const onSlideChange = () => {
      // console.log('slide change');
    };
    const prevMain1 = ref(null);
    const nextMain1 = ref(null);
    const paginationMain1 = ref(null);
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay],
      prevMain1,
      nextMain1,
      paginationMain1,
    };
  },
  methods: {
    freeDemoOpen() {
      this.isFreeDemo = !this.isFreeDemo
    },
    freeApplicationFormOpen() {
      this.isApplicationForm = !this.isApplicationForm
    },
    modalClose() {
      this.isFreeDemo = false
      this.isApplicationForm = false
      document.querySelector('.main__modal.success').style.display = 'none'
    },
    deviceDetection() {
      if(navigator.userAgent.match(/(iPad|iPhone|iPod)/i) ? true : false){
        this.deviceLink = 'https://apps.apple.com/kz/app/educenter/id1543607494';
      }

      var ua = navigator.userAgent.toLowerCase();
      if( ua.indexOf("android") > -1 ){
        this.deviceLink = 'https://play.google.com/store/apps/details?id=com.buginsoft.educenter';
      }
    },
    startTimer: function() {
      const timeNow = new Date().getTime();
      const timeDifference = this.countDownToTime - timeNow;
      const millisecondsInOneSecond = 1000;
      const millisecondsInOneMinute = millisecondsInOneSecond * 60;
      const millisecondsInOneHour = millisecondsInOneMinute * 60;
      const millisecondsInOneDay = millisecondsInOneHour * 24;
      const differenceInDays = timeDifference / millisecondsInOneDay;
      const remainderDifferenceInHours = (timeDifference % millisecondsInOneDay) / millisecondsInOneHour;
      const remainderDifferenceInMinutes = (timeDifference % millisecondsInOneHour) / millisecondsInOneMinute;
      const remainderDifferenceInSeconds = (timeDifference % millisecondsInOneMinute) / millisecondsInOneSecond;
      const remainingDays = Math.floor(differenceInDays);
      const remainingHours = Math.floor(remainderDifferenceInHours);
      const remainingMinutes = Math.floor(remainderDifferenceInMinutes);
      const remainingSeconds =Math.floor(remainderDifferenceInSeconds);
      this.timerOutput = remainingDays + " дн. " + remainingHours + " ч" + " : " + remainingMinutes + " мин " + " : " + remainingSeconds + " с ";
    }
  },
  mounted() {
    setInterval(() => { this.startTimer() }, 1000);
  }
}
</script>

<style scoped>
.main {
  background: url(/src/assets/images/img-main-bg-svg.svg);
  //background-color: #222;
  background-size: cover;
  background-position: bottom;
}
.main__slider {
  width: 50%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.main__slider .swiper-slide{
  border-radius: 16px;
  overflow: hidden;
}

.main__slider .swiper-button-prev,
.main__slider .swiper-button-next {

}
.main__slider .swiper-button-prev::after,
.main__slider .swiper-button-next::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 24px;
  height: 24px;
}
.main__slider .swiper-button-prev::after {
  background-image: url(/src/assets/icons/swiper-left-btn.svg);
}
.main__slider .swiper-button-next::after {
  background-image: url(/src/assets/icons/swiper-right-btn.svg);
}

.bannerSwiper {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
}

.bannerSwiper .swiper1-navigation {
  position: absolute;
  z-index: 10;
  top: 0;
  bottom: 0;
  width: 100%;
  margin: auto;
}

.main__slider .btn-next,
.main__slider .btn-prev {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 2;
  display: flex;
  align-items: center;
}

.main__slider .btn-next.swiper-button-disabled,
.main__slider .btn-prev.swiper-button-disabled {
  opacity: 0.5;
}
.main__slider .pagination {
  position: absolute;
  bottom: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  margin: 20px auto;
  //background: #fff;
  width: auto;
  //padding: 5px;
  border-radius: 6px;
  left: auto;
  right: auto;
}

.main__banner {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
}
.main__banner .circle {
  border-radius: 50%;
  background: rgba(0,0,0,0.2);
  width: 450px;
  height: 450px;
  box-shadow: 8px 7px 12px #007AFF, -6px -3px 11px #007AFF, 5px 11px 18px #007AFF;
}
.main__banner .circle .head,
.main__banner .circle .foot {
  height: 33%;
  display: flex;
  justify-content: center;
  user-select: none;
}
.main__banner .circle .head {
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
  flex-direction: column;
}
.main__banner .circle .head .head-logo {
  display: flex;
  align-items: center;
  gap: 10px;
}
.main__banner .circle .foot {
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
}
.main__banner .circle .head .text{
  font-size: 25px;
  color: var(--white);
  font-weight: 700;
  text-align: center;
}
.main__banner .circle .middle {
  height: 35%;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}
.main__banner .circle .middle .text {
  font-size: 125px;
  text-shadow: 8px 7px 12px #007AFF, -6px -3px 11px #007AFF, 5px 11px 18px #007AFF;
  //text-shadow: 8px 7px 12px #C71743, -6px -3px 11px #C71743, 5px 11px 18px #C71743;
  color: var(--white);
  font-weight: 700;
}
.main__banner .circle .head .text.border {
  border: 1px solid var(--white);
  border-radius: 16px;
  padding: 5px 10px;
}
.main__banner .circle .foot .v {
  color: var(--white);
  text-align: center;
}
.main__banner .circle .foot .text {
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--white);
}

@media (max-width: 991px) {
  .main__banner {
    width: 100%;
  }
  .main__slider {
    width: 100%;
    margin: 30px 0;
  }
  .main__content {
    padding-top: 0px;
  }
  .main .container {
    gap: 50px;
  }
  .main__banner .circle {
    margin-top: 60px;
  }
}
@media (max-width: 600px) {
  .main__banner .circle {
    width: 100%;
  }
  .main__banner .circle .middle .text {
    font-size: 75px;
  }
  .main__banner .circle .head .text {
    font-size: 20px;
  }
  .main__banner .circle .foot .text {
    font-size: 16px;
  }
  .main__banner .circle .foot .v {
    font-size: 14px;
  }
}
@media (max-width: 500px) {
  .main__banner .circle {
    height: 380px;
  }
}
@media (max-width: 420px) {
  .main__banner .circle {
    height: 340px;
  }
  .main__banner .circle .foot {
    gap: 4px;
  }
}
@media (max-width: 370px) {
  height: 300px;
}
</style>